import WeatherWidgetDetails from 'features/Weather/components/WeatherWidgetDetails/WeatherWidgetDetails';
import { useId } from 'react';
import { joinClasses } from 'utils/componentStyles/style.utils';
import {
  earthquakeDetailGroups,
  earthquakeDetails,
} from '../../../../config/earthquakeDetails.config';
import { formatEarthquakeLocation } from '../../../../utils/earthquakes.utils';

const EarthquakeDetailsPanel = ({ earthquake, className, headingLevel: Heading = 'h2' }) => {
  const headingId = useId();

  if (!earthquake) return null;

  const location = formatEarthquakeLocation(earthquake.city);

  return (
    <section
      aria-labelledby={headingId}
      className={joinClasses('earthquake-details-panel d-flex flex-column gap-2', className)}
    >
      <header>
        <div className="small text-uppercase text-secondary fw-semibold">Selected earthquake</div>
        <Heading id={headingId} className="m-0 fs-6 fw-bold text-break">
          {location}
        </Heading>
      </header>

      <WeatherWidgetDetails
        selectedItem={earthquake}
        details={earthquakeDetails}
        layoutGroups={earthquakeDetailGroups}
        containerClassName="weather-map-detail-grid earthquake-details-content"
        iconSize={16}
        ariaLabel={`Details for ${location}`}
      />
    </section>
  );
};

export default EarthquakeDetailsPanel;
